import styled from 'styled-components';

import { Spacer, token } from '@zillow/constellation';

export const StyledPill = styled(Spacer)`
    background-color: ${token('colors.gray100')};
`;
